// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"0b634d96","488":"072bd307","644":"757bacc1","732":"5375b4c8"}[chunkId] + ".chunk.js");